<template>
  <div>
    <h1>
      <b>Ordenes de servicio</b>
    </h1>
    <div class="form-group pull-left">
      <router-link to="/ordenes/crear">
        <button type="button" class="btn btn-success md-elevation-24">
          <i class="fa fa-plus-circle"></i> Crear orden servicio
        </button>
      </router-link>
    </div>
    <div>
      <div
        class="form-group pull-right"
        style="padding-right: 10px; padding-left: 10px; text-align: right;"
      >
        <div class="row">
          <div
            class="col-md-12"
            style="display: flex;
                align-items: center;
                justify-content: center;"
          >
            <div>
              <a-input-search
                size="large"
                v-model="filter"
                v-on:keyup.enter="onKeyPress"
                placeholder="Buscar orden "
                @search="sendRequestOrdenes"
              />
            </div>
            <div style="padding: 5px;">
              <a-button
                shape="circle"
                :loading="procesando"
                type="danger"
                icon="close"
                @click="limpiarFiltros"
              ></a-button>
            </div>
          </div>
        </div>
        <a-pagination
          style="padding-top: 10px"
          @change="onChange"
          :current="page"
          :total="pagination.totalPage"
        />
      </div>
      <div
        class="form-group pull-left"
        style="padding-left: 10px"
        v-if="rol === 'ADMIN_MAIN'"
      >
        <a-radio-group v-model="tipo_pago">
          <a-radio :value="null">
            Todos
          </a-radio>
          <a-radio :value="1">
            Efectivo
          </a-radio>
          <a-radio :value="2">
            Transferencia
          </a-radio>
          <a-radio :value="3">
            Crédito
          </a-radio>
          <a-radio :value="4">
            Abono
          </a-radio>
        </a-radio-group>
      </div>
      <span class="counter pull-right"></span>
      <div class="row">
        <div id="table" class="col-xs-12 table-responsive">
          <Load v-if="procesando" text="Buscando información"></Load>
          <md-table
            md-elevation-24
            v-else
            v-model="row"
            :md-sort.sync="currentSort"
            :md-sort-order.sync="currentSortOrder"
            :md-sort-fn="customSort"
            md-card
          >
            <md-table-empty-state
              md-label="No se encontrarón datos"
            ></md-table-empty-state>
            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <!-- IMPRESIÓN -->
              <div
                v-show="false"
                class="col-md-6"
                :id="`impresion-${item.ordenId}`"
              >
                <div
                  class="texto"
                  style="margin: auto;padding: 15px;border: 0;background: white;max-width: 700px;width: 90%;color: #82899A;"
                >
                  <table
                    width="100%"
                    style="margin: 0;padding: 0;border: 0;"
                  >
                    <!-- <tr style="margin: 0;padding: 0;border: 0;">
                      <td style="margin: 0;padding: 0;border: 0;">
                        <img
                          src="https://ecotronica.s3.amazonaws.com/solucasa.png"
                          alt
                          style="margin: 1em auto 2em;padding: 0;border: 0;display: block;"
                        />
                      </td>
                    </tr> -->
                    <tr style="margin: 0;padding: 0;border: 0;">
                      <h1>SOLUCASA</h1>
                    </tr>
                    <tr style="margin: 0;padding: 0;border: 0;">
                      <td style="margin: 0;padding: 0;border: 0;">
                        <p
                          style="margin: 0;padding: 0;border: 0; font-size: 16px;  font-family: 'Arial Rounded MT Bold';"
                        >
                          <b>Régimen no responsable de IVA.</b>
                        </p>
                        <p
                          style="margin: 0;padding: 0;border: 0; font-size: 16px;  font-family: 'Arial Rounded MT Bold';"
                        >
                          <b>NIT. 42.775.833-7</b>
                        </p>
                        <p
                          style="margin: 0;padding: 0;border: 0; font-size: 16px;  font-family: 'Arial Rounded MT Bold';"
                        >
                          <b>Cra 53 # 61-15, Medellín</b>
                        </p>

                        <p
                          style="margin: 0;padding: 0;border: 0; font-size: 16px;  font-family: 'Arial Rounded MT Bold';"
                        >
                          <b>Tel. 604 4734651 - Móvil 324 454 0402</b>
                        </p>
                        <br />
                        <p
                          style="margin: 0;padding: 0;border: 0; font-size: 16px;  font-family: 'Arial Rounded MT Bold';"
                        >
                          <b>Fecha: {{ getFecha() }}</b>
                        </p>
                        <br />
                        <h4
                          style="margin: 0;padding: 0;border: 0; font-size: 22px;  font-family: 'Arial Rounded MT Bold';"
                        >
                          <b>{{
                            `${item.clienteNombre} ${
                              item.clienteApellidos
                            }`
                          }}</b>
                        </h4>
                        <p
                          style="margin: 0;padding: 0;border: 0; font-size: 20px;  font-family: 'Arial Rounded MT Bold';"
                        >
                          <b>Orden de servicio N°</b>
                          {{ item.ordenId }}
                        </p>
                        <p
                          style="margin: 0;padding: 0;border: 0; font-size: 16px;  font-family: 'Arial Rounded MT Bold';"
                        >
                          <b>Síntoma:</b>
                          {{ item.sintoma }}
                        </p>
                        <p
                          style="margin: 0;padding: 0;border: 0; font-size: 16px;  font-family: 'Arial Rounded MT Bold';"
                        >
                          <b>Marca:</b>
                          {{ item.marca }}
                        </p>
                        <p
                          style="margin: 0;padding: 0;border: 0; font-size: 16px;  font-family: 'Arial Rounded MT Bold';"
                        >
                          <b>Diagnóstico:</b>
                          {{ item.diagnostico }}
                        </p>
                        <p
                          style="margin: 0;padding: 0;border: 0; font-size: 16px;  font-family: 'Arial Rounded MT Bold';"
                        >
                          <b>Estado:</b>
                          {{ JSON.parse(item.estado).estado }}
                        </p>
                        <p
                          style="margin: 0;padding: 0;border: 0; font-size: 16px;  font-family: 'Arial Rounded MT Bold';"
                        >
                          <b>Servicio:</b>
                          {{ item.servicio }}
                        </p>
                        <p
                          style="margin: 0;padding: 0;border: 0; font-size: 16px;  font-family: 'Arial Rounded MT Bold';"
                        >
                          <b>Accesorios:</b>
                          {{ item.accesorios }}
                        </p>
                        <p
                          style="margin: 0;padding: 0;border: 0; font-size: 16px;  font-family: 'Arial Rounded MT Bold';"
                          v-if="item.precio || item.precio > 0"
                        >
                          <b>Precio:</b>
                          {{ item.precio | currency }}
                        </p>
                        <p
                          style="margin: 0;padding: 0;border: 0; font-size: 16px;  font-family: 'Arial Rounded MT Bold';"
                        >
                          <b>Recomendaciones:</b>
                          {{
                            item.recomendaciones
                              ? item.recomendaciones
                              : 'Sin recomendaciones'
                          }}
                        </p>
                        <!-- <p style="margin: 0;padding: 0;border: 0;" v-if="observaciones != ''"><b>Observaciones: </b>{{observaciones}}</p> -->
                        <p
                          style="margin: 0;padding: 0;border: 0; font-size: 16px;  font-family: 'Arial Rounded MT Bold';"
                          v-if="
                            item.servicio === 'Venta' ||
                              item.servicio === 'Reparacion'
                          "
                        >
                          <b>Garantía:</b>
                          {{
                            item.servicio === 'Venta'
                              ? '1 Mes'
                              : item.servicio === 'Reparacion'
                              ? '1 Mes'
                              : ''
                          }}
                        </p>
                        <p
                          style="margin: 0;padding: 0;border: 0; font-size: 16px;  font-family: 'Arial Rounded MT Bold';"
                        >
                          <b>Nota:</b> Si pasados 3 meses su producto
                          no ha sido retirado, SOLUCASA dispondrá de
                          este. (Ley 1480 de 2011). Las garantías se
                          cubren de acuerdo al daño reparado.
                        </p>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
              <md-table-cell
                translate="no"
                md-label="N° OS"
                md-sort-by="ordenId"
                md-numeric
                >{{ item.ordenId }}</md-table-cell
              >
              <md-table-cell
                translate="no"
                md-label="FECHA CREACIÓN"
                md-sort-by="created_at"
                >{{ `${item.created_at}` }}</md-table-cell
              >
              <md-table-cell
                translate="no"
                md-label="CLIENTE"
                md-sort-by="clienteNombre"
              >
                <router-link
                  translate="no"
                  :to="{
                    name: 'editar-orden-servicio',
                    params: {
                      ordenId: item.ordenId,
                      proviene: 'general',
                    },
                  }"
                >
                  <a href="#">
                    {{
                      `${item.clienteNombre} ${
                        item.clienteApellidos
                      } - ${item.celularCliente}`
                    }}
                  </a>
                </router-link>
              </md-table-cell>
              <md-table-cell
                translate="no"
                md-label="QUIÉN RECIBE"
                md-sort-by="usuario_recibe"
              >
                {{ item.usuario_recibe.split('-')[1] }}
              </md-table-cell>
              <md-table-cell
                translate="no"
                md-label="TÉCNICO"
                md-sort-by="tecnicoNombre"
              >
                {{ `${item.tecnicoNombre} ${item.tecnicoApellidos}` }}
              </md-table-cell>
              <md-table-cell
                translate="no"
                md-label="SERVICIO"
                md-sort-by="servicio"
              >
                <router-link
                  :to="{
                    name: 'editar-orden-servicio',
                    params: {
                      ordenId: item.ordenId,
                      proviene: 'general',
                    },
                  }"
                >
                  <a href="#">
                    {{
                      `${
                        row.servicio === 'Análisis' ||
                        item.servicio === 'Analisis'
                          ? item.servicio_realizado != null
                            ? item.servicio_realizado.toUpperCase()
                            : 'ANÁLISIS EN PROCESO'
                          : item.servicio.toUpperCase()
                      }`
                    }}
                  </a>
                </router-link>
              </md-table-cell>
              <md-table-cell
                translate="no"
                md-label="MARCA"
                md-sort-by="marca"
                >{{ item.marca }}</md-table-cell
              >
              <md-table-cell
                translate="no"
                md-label="ESTADO"
                md-sort-by="estado"
              >
                <router-link
                  :to="{
                    name: 'editar-orden-servicio',
                    params: {
                      ordenId: item.ordenId,
                      proviene: 'general',
                    },
                  }"
                >
                  <a href="#">
                    {{ `${JSON.parse(item.estado).estado}` }}
                    <i
                      v-if="
                        JSON.parse(item.estado).estado === 'Pendiente'
                      "
                      class="fa fa-info-circle"
                    ></i>
                    <md-tooltip
                      v-if="
                        JSON.parse(item.estado).pendiente.autorizacion
                      "
                      md-direction="right"
                      >Autorización</md-tooltip
                    >
                    <md-tooltip
                      v-if="
                        JSON.parse(item.estado).pendiente.repuesto
                      "
                      md-direction="right"
                      >Repuesto</md-tooltip
                    >
                    <md-tooltip
                      v-if="
                        JSON.parse(item.estado).pendiente.cotizacion
                      "
                      md-direction="right"
                      >Cotización</md-tooltip
                    >
                  </a>
                </router-link>
              </md-table-cell>
              <md-table-cell
                translate="no"
                md-label="VALOR SERVICIO"
                md-sort-by="precio"
                >{{ item.precio | currency }}
                <md-chip
                  v-if="item.valor_restante"
                  style="font-size: 12px;"
                  class="md-primarys md-size-small"
                  >Resta {{ item.valor_restante | currency }}</md-chip
                ></md-table-cell
              >
              <!-- <md-table-cell
                v-if="item.proceso && rol === 'ANALISTA'"
                translate="no"
                md-label="ANALISIS"
                md-sort-by="terminado"
              >
                {{
                  JSON.parse(item.proceso).analisis.terminado
                    ? 'Terminado'
                    : 'En proceso'
                }}
              </md-table-cell>-->
              <md-table-cell
                translate="no"
                md-label="TERMINADO"
                md-sort-by="terminado"
                >{{
                  item.fecha_terminado
                    ? item.fecha_terminado
                    : 'SIN TERMINAR'
                }}</md-table-cell
              >
              <md-table-cell
                translate="no"
                md-label="ENTREGADO"
                md-sort-by="entregado"
              >
                {{
                  item.fecha_entrega
                    ? item.fecha_entrega
                    : 'SIN ENTREGAR'
                }}
                <md-chip
                  v-if="item.tipo_pago"
                  style="font-size: 12px;"
                  class="md-primarys md-size-small"
                  >{{ item.tipo_pago }}</md-chip
                ></md-table-cell
              >
              <md-table-cell translate="no" md-label="OPCIONES">
                <a-dropdown>
                  <a-menu slot="overlay" @click="handleMenuClick">
                    <a-menu-item key="1">
                      <router-link
                        :to="{
                          name: 'editar-orden-servicio',
                          params: {
                            ordenId: item.ordenId,
                            proviene: 'general',
                          },
                        }"
                      >
                        <a href="#">Ver detalle</a>
                      </router-link>
                    </a-menu-item>
                    <a-menu-item
                      v-if="
                        item.terminado === 1 && item.entregado === 0
                      "
                      key="2"
                    >
                      <a @click="openModalPagar(item)" href="#"
                        >Pagar y entregar</a
                      >
                    </a-menu-item>
                    <a-menu-item
                      v-if="
                        item.terminado === 1 &&
                          item.entregado === 1 &&
                          rol === 'ADMIN_MAIN'
                      "
                      key="3"
                    >
                      <a
                        @click="cambiarEstadoOrden(item.ordenId)"
                        href="#"
                        >Cambiar estado de entrega</a
                      >
                    </a-menu-item>
                    <a-menu-item key="4">
                      <a
                        @click="
                          generarImpresion(
                            `impresion-${item.ordenId}`
                          )
                        "
                        href="#"
                        >Imprimir</a
                      >
                    </a-menu-item>
                  </a-menu>
                  <a-button type="primary" style="margin-left: 8px">
                    Opciones
                    <a-icon type="down" />
                  </a-button>
                </a-dropdown>
              </md-table-cell>
            </md-table-row>
          </md-table>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12 form-inline">
          <!-- <a-menu
            :defaultSelectedKeys="['1']"
            :defaultOpenKeys="['sub1']"
            mode="inline"
            :selectedKeys="[current]"
            @click="handleClick"
          >
            <a-sub-menu key="1">
              <span slot="title"><a-icon type="setting" /><span>Navigation Four</span></span>
              <a-menu-item key="7">Option 7</a-menu-item>
              <a-menu-item key="8">Option 8</a-menu-item>
              <a-menu-item key="9">Option 9</a-menu-item>
              <a-menu-item key="10">Option 10</a-menu-item>
            </a-sub-menu>
          </a-menu>-->
          <!-- <datatable-pager v-model="page" type="abbreviated" :per-page="per_page"></datatable-pager> -->
          <!-- <a-pagination  @change="onChange" :current="page" :total="pagination.totalPage" /> -->
        </div>
      </div>
    </div>
    <loading
      :active.sync="loading"
      :can-cancel="false"
      :on-cancel="onCancel"
      loader="dots"
      color="#164880"
      :is-full-page="true"
    ></loading>
    <modal-pago
      @onSuccess="getOrdenes()"
      :orden="ordenSelect"
      ref="modalPago"
    ></modal-pago>
  </div>
</template>
<script>
import ServiceApi from '../../ServiceApi';
import Loading from 'vue-loading-overlay';
import Load from '../Helpers/Loading';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import { mapMutations, mapState } from 'vuex';
import Moment from 'moment';
import ModalPago from './ModalPago.vue';
export default {
  name: 'ordenes-servicio',
  components: {
    Loading,
    Load,
    ModalPago,
  },
  computed: {
    ...mapState(['usuario', 'rol', 'usuarioId', 'globalFilter']),
  },
  data() {
    return {
      filter: '',
      currentSort: 'ordenId',
      currentSortOrder: 'desc',
      loading: true,
      procesando: false,
      ordenSelect: null,
      pagination: {
        page: 1,
        total: 0,
        totalPage: 10,
        search: '',
      },
      page: 1,
      row: [],
      per_page: 100,
      tipo_pago: null,
    };
  },
  watch: {
    filter() {
      this.pagination.search = this.filter;
      // this.page = 1
      // this.pagination.page = 1
      // this.procesando = true
      // this.getOrdenes()
      this.SET_GLOBAL_FILTER(this.filter);
    },
    tipo_pago() {
      this.getOrdenes();
    },
  },
  created() {
    if (this.globalFilter) {
      this.filter = this.globalFilter;
    }
    this.getOrdenes();
  },
  methods: {
    ...mapMutations(['SET_GLOBAL_FILTER']),
    getFecha() {
      return Moment().format('YYYY/MM/DD h:mm:ss');
    },
    generarImpresion(item) {
      let element = document.getElementById(item);
      var ventana = window.open('', 'PRINT', 'height=500,width=700');
      ventana.document.write(
        '<html><head><title>' + 'SOLUCASA' + '</title>'
      );
      ventana.document.write('</head><body >');
      ventana.document.write(element.innerHTML);
      ventana.document.write('</body></html>');
      ventana.document.close();
      ventana.focus();
      ventana.print();
      ventana.close();
      return true;
    },
    sendRequestOrdenes() {
      this.tipo_pago = null;
      this.pagination.search = this.filter;
      this.page = 1;
      this.pagination.page = 1;
      this.procesando = true;
      this.getOrdenes();
    },
    onKeyPress() {
      this.sendRequestOrdenes();
    },
    limpiarFiltros() {
      this.filter = '';
      this.sendRequestOrdenes();
    },
    onCancel() {},
    onChange(page) {
      this.loading = true;
      this.page = page;
      this.pagination.page = page;
      this.getOrdenes();
    },
    getOrdenes() {
      // this.loading = true;
      let data = {
        filter: this.pagination,
        tipo_pago: this.tipo_pago,
        orden: {
          entidad: this.currentSort,
          tipo: this.currentSortOrder,
        },
      };
      ServiceApi.post(`/ordenes/list`, data)
        .then(response => {
          // console.log('RESPUESTA:::', response.data);
          let data = response.data.data;
          this.row = data.ordenes;
          let pagination = data.paginacion;
          this.pagination.totalPage = pagination.lastPage * 10;
          this.pagination.total = pagination.total;
          // if(!data.ordenes.length)this.$noty.warning('No se encontraron ordenes de servicio creadas')
          this.loading = false;
          this.procesando = false;
        })
        .catch(err => {
          // this.$noty.error('Ocurrio un error al consultar las tarjetas')
          this.loading = false;
          this.procesando = false;
          this.$router.push('/');
        });
    },
    showModal(ordenId) {
      Swal.fire({
        type: 'success',
        title: `Se acaba de generar la entrega de la orden # ${ordenId}`,
        showConfirmButton: false,
        timer: 3000,
      });
    },
    openModalPagar(orden) {
      if (orden.precio === 0) {
        this.entregarOrden(orden.ordenId);
      } else {
        this.ordenSelect = orden;
        this.$refs.modalPago.visible = true;
      }
    },
    entregarOrden(ordenId) {
      this.loading = true;
      let data = {
        ordenId,
        entregado: true,
        fecha: Moment().format('YYYY/MM/DD h:mm:ss'),
      };
      ServiceApi.post('/orden/entregar', data)
        .then(response => {
          this.getOrdenes();
          this.loading = false;
          this.showModal(ordenId);
        })
        .catch(err => {
          this.$noty.error(
            'Ocurrio un error al consultar las tarjetas'
          );
          this.loading = false;
          this.$router.push('/');
        });
    },
    customSort(value) {
      if (
        this.currentSort === 'ordenId' ||
        this.currentSort === 'precio' ||
        this.currentSort === 'terminado' ||
        this.currentSort === 'entregado'
      ) {
        this.getOrdenes();
      } else {
        return value.sort((a, b) => {
          const sortBy = this.currentSort;
          if (this.currentSortOrder === 'desc') {
            return a[sortBy].localeCompare(b[sortBy]);
          }

          return b[sortBy].localeCompare(a[sortBy]);
        });
      }
    },
    handleMenuClick() {},
    cambiarEstadoOrden(ordenId, pos) {
      this.loading = true;
      ServiceApi.post('/orden/cambiar/entrega', { ordenId })
        .then(response => {
          this.row.filter(
            o => o.ordenId === ordenId
          )[0].entregado = 0;
          this.row.filter(
            o => o.ordenId === ordenId
          )[0].fecha_entrega = null;
          this.loading = false;
        })
        .catch(err => {
          this.$noty.error(
            'Ocurrio un error al cambiar el estado de la orden'
          );
          this.loading = false;
        });
    },
  },
};
</script>
